"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeSelectorWithRadio = void 0;
var react_1 = __importDefault(require("react"));
var moment_1 = __importDefault(require("moment"));
var antd_1 = require("antd");
var utils_1 = require("../../utils");
var transifex_1 = require("../../transifex");
var RangePicker = antd_1.DatePicker.RangePicker;
var p = utils_1.createPrefixer("wh-UI-RangeSelectorWithRadio-");
var classes = {
    wrapper: p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["wrapper"], ["wrapper"]))),
};
var preSetList = [
    {
        label: transifex_1.TX_ALL_DAY,
        start: moment_1.default().startOf("day"),
        end: moment_1.default().endOf("day"),
    },
    {
        label: transifex_1.TX_ALL_WEEK,
        start: moment_1.default().startOf("week"),
        end: moment_1.default().endOf("week"),
    },
    {
        label: transifex_1.TX_ALL_MONTH,
        start: moment_1.default().startOf("month"),
        end: moment_1.default().endOf("month"),
    },
    {
        label: transifex_1.TX_ALL_YEAR,
        start: moment_1.default().startOf("year"),
        end: moment_1.default().endOf("year"),
    },
];
var RangeSelectorWithRadio = function (_a) {
    var onChange = _a.onChange, value = _a.value, _b = _a.rangeProps, rangeProps = _b === void 0 ? {} : _b, _c = _a.radioButtonProps, radioButtonProps = _c === void 0 ? {} : _c, _d = _a.disabled, allDisabled = _d === void 0 ? false : _d;
    var isSelected = function (start, end) {
        return (moment_1.default(start).isSame(value[0], "day") &&
            moment_1.default(end).isSame(value[1], "day"));
    };
    return (react_1.default.createElement(antd_1.Row, { gutter: 8, className: classes.wrapper },
        preSetList.map(function (_a) {
            var _b;
            var label = _a.label, end = _a.end, start = _a.start;
            return (react_1.default.createElement(antd_1.Col, null,
                react_1.default.createElement(antd_1.Button, __assign({}, radioButtonProps, { onClick: function (evt) {
                        var _a;
                        onChange([start, end]);
                        (_a = radioButtonProps.onChange) === null || _a === void 0 ? void 0 : _a.call(radioButtonProps, evt);
                    }, type: ((_b = radioButtonProps.type) === null || _b === void 0 ? void 0 : _b.call(radioButtonProps, isSelected(start, end))) ||
                        (isSelected(start, end) ? "primary" : "text"), disabled: allDisabled || (radioButtonProps === null || radioButtonProps === void 0 ? void 0 : radioButtonProps.disabled) }), label)));
        }),
        react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(RangePicker, __assign({}, rangeProps, { value: value, onChange: function (dates, secondArg) {
                    var _a;
                    if (dates && (dates === null || dates === void 0 ? void 0 : dates[0]) && (dates === null || dates === void 0 ? void 0 : dates[1])) {
                        // @ts-expect-error WIP
                        onChange(dates);
                        (_a = rangeProps.onChange) === null || _a === void 0 ? void 0 : _a.call(rangeProps, dates, secondArg);
                    }
                }, disabled: allDisabled || (rangeProps === null || rangeProps === void 0 ? void 0 : rangeProps.disabled) })))));
};
exports.RangeSelectorWithRadio = RangeSelectorWithRadio;
RangeSelectorWithRadio.classes = classes;
var templateObject_1;
